import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const jazzHr = defineConnector({
  identifier: "jazzHr",
  name: "JazzHR",
  tagLine: "Recruiting and applicant tracking",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: () => "https://api\\.resumatorapi\\.com/.*",
  auth: (app) => queryAuth([{ name: "apikey", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your JazzHR API key",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to JazzHR and navigate to **Settings > Integrations > API** to find your API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => `https://api.resumatorapi.com/v1/applicants`,
  },
});
